import { Routes } from 'react-router-dom';
import { createRoute, useEntityUrl, Route } from 'framework/routing';
import EmployeeLeavesBalancesList from 'domain/people/employee/leavebalance/BalancesList';
import { PEOPLE_MANAGEMENT_LEAVE_BALANCE_READ } from './shared/constants';
import { ProtectedRoute } from 'framework/authorization';
import { Page404 } from 'framework/statusPages';
import useAuthenticationService from 'infrastructure/security/authentication/authenticationService';
import { useEmployeeUrl, WORKERS_PATH } from 'domain/shared/employee';

const BALANCES_PATH = 'leaves';

const useLeavesBalancesRoute = () => {
  const { singleEntityRoute: employeeRoute } = createRoute({ listRoute: WORKERS_PATH });

  return createRoute({
    listRoute: `${employeeRoute}/${BALANCES_PATH}`,
  });
};

export const useLeavesBalancesUrl = () => {
  const { getSingleEntityUrl } = useEmployeeUrl();
  const employeeLink = getSingleEntityUrl();
  return useEntityUrl({
    baseLink: `${employeeLink}/${BALANCES_PATH}`,
  });
};

const LeaveBalanceRouter = () => {
  const { isAuthenticated } = useAuthenticationService();
  const { listRoute } = useLeavesBalancesRoute();

  return (
    <Routes>
      <Route
        path={listRoute}
        element={
          <ProtectedRoute permissionToCheck={PEOPLE_MANAGEMENT_LEAVE_BALANCE_READ}>
            <EmployeeLeavesBalancesList />
          </ProtectedRoute>
        }
      />

      <Route path="*" element={<Page404 isAuthenticated={isAuthenticated} />} />
    </Routes>
  );
};

export default LeaveBalanceRouter;
